import api from 'src/config/api';
import {
	IAIModelFile,
	IAIModelFileDetails,
	IGetAIModelFilesParams,
	IUpdateAIModelFileRequest,
	IUploadAIModelFileRequest,
} from 'src/features/ai_model_file/domain/types';

export const AIModelFileApi = {
	uploadAIModelFile: async (
		AIModelId: number,
		requestBody: IUploadAIModelFileRequest,
		siteSlug: string,
	): Promise<IAIModelFile> => {
		const formData = new FormData();
		formData.append('file', requestBody.file);
		const metadata = {
			name: requestBody.name,
			description: requestBody.description || '',
			sha_256: requestBody.sha_256,
		};
		formData.append('meta_data', JSON.stringify(metadata));
		const response = await api.post(
			`/api/v1/ai-model/${AIModelId}/file/upload`,
			formData,
			{
				headers: {
					Site: siteSlug,
					'Content-Type': 'multipart/form-data',
				},
			},
		);
		return response.data;
	},

	getAIModelFiles: async (
		AIModelId: number,
		requestParams: IGetAIModelFilesParams,
		siteSlug: string,
	): Promise<IPaginatedResponse<IAIModelFileDetails>> => {
		const { page = 1, sort, order, active } = requestParams;

		const params = new URLSearchParams({
			page: page.toString(),
			...(sort && order && { sort, order }),
			...(active && { active }),
		});

		const response = await api.get(`/api/v1/ai-model/${AIModelId}/files`, {
			params,
			headers: { Site: siteSlug },
		});

		return response.data;
	},

	updateAIModelFile: async (
		fileId: number,
		requestBody: IUpdateAIModelFileRequest,
		siteSlug: string,
	): Promise<IAIModelFileDetails> => {
		const response = await api.patch(
			`/api/v1/ai-model-file/${fileId}`,
			requestBody,
			{
				headers: { Site: siteSlug },
			},
		);
		return response.data;
	},

	deleteAIModelFile: async (
		fileId: number,
		siteSlug: string,
	): Promise<void> => {
		await api.delete(`/api/v1/ai-model-file/${fileId}`, {
			headers: { Site: siteSlug },
		});
	},
};
